import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RoleType } from '@enums/role-type.enums';
import { DomainRole } from '@services/genesys-cloud-user.interface';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-education-course-list',
  templateUrl: './education-course-list.component.html',
  styleUrls: ['./education-course-list.component.scss'],
  imports: [NgTemplateOutlet],
})
export class EducationCourseListComponent {
  @Input() role: DomainRole;
  @Output() readonly linkClick = new EventEmitter<boolean>();

  /**
   * Emit link click event to parent
   */
  onLinkClick(): void {
    console.log('Education Course Link clicked');
    this.linkClick.emit(true);
  }

  /**
   * Domain Role Type Enum
   * @returns {typeof RoleType}
   */
  public get roleType(): typeof RoleType {
    return RoleType;
  }
}
